<div
  #modalContents
  [class]="lmodalContentsClassWithWidth"
  aria-modal="true"
  role="dialog"
  [attr.aria-labelledby]="'Select the language'"
>
  <div #modalHead [class]="lmodalHeaderClass">
    <div class="p-modal-head02">
      <h3 class="c-message-box__title c-message-box__title--em" [innerHTML]="'label.languageGroup' | staticMsg"></h3>
    </div>
  </div>

  <div #modalBody [class]="lmodalBodyClass">
    <div class="p-form-layout01">
      <div class="p-form-layout01__item" style="padding-top: 0px">
        <div>
          <br />
          <h3 class="c-message-box__title c-message-box__title--em">{{ 'label.displayLanguage' | staticMsg }}</h3>
          <br />
          <p class="c-message-box__contents" [innerHTML]="messageContent | staticMsg"></p>
          <br />
          <div class="p-input-block01__row-body">
            <div class="p-input-block01__row-body-item">
              <asw-radio-group
                id="language-selection-modal-radio-group1"
                name="selectLanguage"
                [formControl]="langFormControl"
                direction="sp-vertical"
                [legend]="'label.languageGroup' | staticMsg"
              >
                <asw-radio-button
                  *ngFor="let item of languageList | async"
                  value="{{ item.code }}"
                  label="{{ item.label }}"
                ></asw-radio-button>
              </asw-radio-group>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div #modalFooter [class]="lmodalFooterClass">
    <div class="p-modal-foot02">
      <asw-button
        id="language-selection-modal-cancel-button"
        [label]="'label.goBack' | staticMsg"
        type="secondary"
        (click$)="cancelEvent()"
      ></asw-button>
      <asw-button
        id="language-selection-modal-submit-button"
        [label]="'label.proceed' | staticMsg"
        type="primary"
        (click$)="continueEvent()"
      ></asw-button>
    </div>
  </div>
</div>
